import React, { useEffect, useMemo, useState } from 'react';

import CardCommon from '@/pages/opinion/components/CardCommon';
import { connect, useDispatch, Dispatch, useIntl } from 'umi';
import './index.scss';

import { addWithoutSingleData } from '@/pages/opinion/utils';
import Chart from './chart';
import { getOverviewPcConsoleOperate } from '@/pages/opinion/services';
import useConstantText from './useConstantText';
import { useMentionsSentimentData } from './useMentionsSentimentData';
import BubbleCommon, {
  commonSentimentTips,
} from '@/pages/opinion/components/BubbleCommon';

function MentionsSentiment(props: any) {
  const dispatch: Dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const {
    userInfo,
    gameInfo,
    filter,
    dau,
    download,
    revenue,
    dauRevDlsLoading = true,
  } = props;
  const [curFilter, setCurFilter] = useState('0');
  const [curSubFilter, setCurSubFilter] = useState('');

  const [title, setTitle] = useState(['Mentions', 'Brand Health']);
  const { filters, getTitleOneText } = useConstantText({
    filter,
    gameInfo,
  });
  const getAppList = () => {
    dispatch({
      type: 'opinionPerformance/getOverviewDauRevDls',
      payload: {
        id_type: gameInfo.id_type,
        edition_unified_id: gameInfo.edition_unified_id,
        entity_type: gameInfo.entity_type,

        region_type: filter.region_type,
        region: filter.region,
        start_time: filter?.start_time,
        end_time: filter?.end_time,
        date_type: filter?.date_type,
        metric: curSubFilter.toLowerCase(),

        // app_ids: appIdList,
        // data_sources: ['appannie'],
        // sort_type: 'desc',
        // sort_field: `sum_${curSubFilter.toLowerCase()}`,
      },
    });
  };

  const [pcConsoleData, setPcConsoleData] = useState({});
  const [pcConsoleLoading, setPcConsoleLoading] = useState(false);
  const getPcConsoleAppData = () => {
    setPcConsoleLoading(true);
    getOverviewPcConsoleOperate({
      ...gameInfo,
      regions: filter.region,
      region_type: filter.region_type,
      start_time: filter.start_time,
      end_time: filter.end_time,
      date_type: filter.date_type,
    })
      .then((data: any) => {
        let { timeline_of_end_time, timeline_of_start_time, list } = data || {};

        list = addWithoutSingleData(
          timeline_of_start_time,
          timeline_of_end_time,
          filter.date_type,
          list,
          {
            ccv: 0,
            pcu: 0,
            revenue: 0,
            units: 0,
          },
        );

        const chartData: any = {};
        list.map((item: any) => {
          ['ccv', 'pcu', 'revenue', 'units'].map((key) => {
            const newKey = key === 'revenue' ? 'pcRevenue' : key;
            if (!chartData[newKey]) {
              chartData[newKey] = [];
            }
            chartData[newKey].push({
              time: item.time,
              value: item[key] || 0,
              predict: 0,
            });
          });
        });

        setPcConsoleData(chartData);
      })
      .catch(() => {
        setPcConsoleData({});
      })
      .finally(() => {
        setPcConsoleLoading(false);
      });
  };

  const {
    getOverviewMentionsSentimentServerData,
    dataList,
    loading: mentionsSentimentLoading,
  } = useMentionsSentimentData();

  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;
    const getTabDataFunc =
      gameInfo.entity_type === 'mobile' ? getAppList : getPcConsoleAppData;
    switch (curFilter) {
      case '0':
        setTitle(['Mentions', 'Brand Health']);
        getOverviewMentionsSentimentServerData({
          ...filter,
          ...gameInfo,
          user_id: userInfo.userid,
          statistics_field: 'mentions',
        });
        break;
      case '1':
        setTitle(['Mentions', curSubFilter]);
        console.log('处理 1 情况', curSubFilter);

        getTabDataFunc();
        break;
      case '2':
        setTitle(['Brand Health', curSubFilter]);
        console.log('处理 2 情况', curSubFilter);

        getTabDataFunc();
        break;
      default:
        setTitle(['Mentions', 'Brand Health']);
    }
  }, [userInfo, filter, curFilter, curSubFilter]);

  const isLoading = useMemo(() => {
    if (curFilter === '0') {
      return mentionsSentimentLoading;
    }
    if (mentionsSentimentLoading) {
      return true;
    }

    return gameInfo.entity_type === 'mobile'
      ? dauRevDlsLoading
      : pcConsoleLoading;
  }, [mentionsSentimentLoading, dauRevDlsLoading, pcConsoleLoading]);

  const subDataMap: any = useMemo(
    () => ({
      ...pcConsoleData,
      DAU: dau,
      Revenue: revenue,
      Download: download,
    }),
    [pcConsoleData, dau, download, revenue],
  );

  const isEmpty = useMemo(() => {
    if (curFilter === '0') {
      return !Array.isArray(dataList) || dataList?.length === 0;
    }

    const data = subDataMap[curSubFilter];
    return !Array.isArray(data) || data?.length === 0;
  }, [curFilter, dataList, subDataMap]);

  const [noContentHeight, chartHeight] = useMemo(() => {
    if (filter.date_type === 'hourly') return [410, 408];
    if (['console', 'pc'].includes(gameInfo.entity_type) || curFilter === '0')
      return [390, 370];

    return [334, 350];
  }, [gameInfo, filter, curFilter]);

  const isNoData = useMemo(
    () => (curFilter === '0' ? !dataList : !subDataMap?.[curSubFilter]),
    [curSubFilter, subDataMap, dataList, curFilter],
  );

  return (
    <CardCommon
      className="mentions-sentiment-card-wrapper"
      loading={isLoading}
      empty={isEmpty}
      subFilterClassName="dbo-sub-filter-box"
      loadingHeight={noContentHeight}
      emptyHeight={noContentHeight}
      keepFiltersSpaceHeight={44}
      keepSubFiltersSpaceHeight={21}
      title={
        <span style={{ display: 'flex' }}>
          <span>{formatMessage({ id: 'Mentions & Sentiment' })}</span>
          <BubbleCommon tipsMap={commonSentimentTips}></BubbleCommon>
        </span>
      }
      filters={filters}
      handleFilterOnChange={(value) => setCurFilter(value)}
      handleSubFilterOnChange={(value) => setCurSubFilter(value)}
    >
      <div className="mentions-sentiment-card">
        <Chart
          dataList={dataList}
          filter={filter}
          leftTitle={formatMessage({
            id: getTitleOneText(title[0]) ?? 'Mentions',
          })}
          rightTitle={formatMessage({
            id: getTitleOneText(title[1]) ?? 'Brand Health',
          })}
          isMobile={gameInfo.entity_type === 'mobile'}
          subTitle={getTitleOneText(curSubFilter)}
          subData={subDataMap}
          curFilter={curFilter}
          isNoData={isNoData}
          curSubFilter={curSubFilter}
          height={chartHeight}
        ></Chart>
      </div>
    </CardCommon>
  );
}

export default connect((state: any) => {
  const { loading, home, opinionCommon, opinionPerformance } = state;

  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,
    gameInfo: opinionCommon.gameInfo,

    // mentionsSentimentLoading:
    //   loading.effects['opinionPerformance/getOverviewMentionsSentiment'],
    // mentionsSentiment: opinionPerformance.mentionsSentiment,

    dauRevDlsLoading:
      loading.effects['opinionPerformance/getOverviewDauRevDls'],
    revenue: opinionPerformance.revenue,
    dau: opinionPerformance.dau,
    download: opinionPerformance.download,
  };
})(MentionsSentiment);
